module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Klaim List ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "slot": "extra",
      "disabled": !_vm.isSearchShow,
      "loading": _vm.isPrintClaimList,
      "icon": "ios-printer-outline",
      "type": "success",
      "size": "small"
    },
    on: {
      "on-change": _vm.updateFilter,
      "click": function($event) {
        return _vm.printClaimList()
      }
    },
    slot: "extra"
  }, [(!_vm.isPrintClaimList) ? _c('span', [_vm._v("Cetak Klaim List ")]) : _c('span', [_vm._v("Sedang diproses.....")])]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Pilih Rekening Bank",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.updateFilter
    },
    model: {
      value: (_vm.bankAccountId),
      callback: function($$v) {
        _vm.bankAccountId = $$v
      },
      expression: "bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Department",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.updateFilter
    },
    model: {
      value: (_vm.itemDeptId),
      callback: function($$v) {
        _vm.itemDeptId = $$v
      },
      expression: "itemDeptId"
    }
  }, _vm._l((_vm.itemsDept), function(itemDept) {
    return _c('Option', {
      key: itemDept.id,
      attrs: {
        "value": itemDept.id
      }
    }, [_vm._v(_vm._s(itemDept.value))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Select', {
    attrs: {
      "name": "branchSelected",
      "placeholder": "Branch",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.updateFilter
    },
    model: {
      value: (_vm.branchSelected),
      callback: function($$v) {
        _vm.branchSelected = $$v
      },
      expression: "branchSelected"
    }
  }, _vm._l((_vm.branchList), function(type) {
    return _c('Option', {
      key: type.value,
      attrs: {
        "value": type.value
      }
    }, [_vm._v("\n                    " + _vm._s(type.label) + "\n                ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Category",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.updateFilter
    },
    model: {
      value: (_vm.categoryId),
      callback: function($$v) {
        _vm.categoryId = $$v
      },
      expression: "categoryId"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('Option', {
      key: category.id,
      attrs: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(category.value))])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Klaim")]), _vm._v(" "), _c('Date-picker', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd"
    },
    on: {
      "on-change": _vm.updateFilter
    },
    model: {
      value: (_vm.dateKlaimSelect),
      callback: function($$v) {
        _vm.dateKlaimSelect = $$v
      },
      expression: "dateKlaimSelect"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "span": "5"
    }
  }, [_c('div', {
    staticClass: "custom-group-switch"
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isGroupFilter),
      callback: function($$v) {
        _vm.isGroupFilter = $$v
      },
      expression: "isGroupFilter"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("Group")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("Mark")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-right"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == false),
      expression: "isGroupFilter == false"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingMarking
    },
    on: {
      "on-change": function($event) {
        return _vm.updateFilter()
      }
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                          " + _vm._s(option.label))])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "move-left"
    }
  }, [_c('Select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == true),
      expression: "isGroupFilter == true"
    }],
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Select Group Name",
      "remote-method": _vm.getMarkingGroupByCode,
      "loading": _vm.isLoadingMarking
    },
    on: {
      "on-change": function($event) {
        return _vm.updateFilter()
      }
    },
    model: {
      value: (_vm.markingGroupIdSelected),
      callback: function($$v) {
        _vm.markingGroupIdSelected = $$v
      },
      expression: "markingGroupIdSelected"
    }
  }, _vm._l((_vm.optionMarkingGroups), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v("\n                          " + _vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearchShow),
      expression: "isSearchShow"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingMarking,
      "icon": "ios-search"
    },
    on: {
      "click": _vm.searchClickHandle
    }
  }, [(!_vm.isLoadingMarking) ? _c('span', [_vm._v("Cari")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingMarking),
      expression: "isLoadingMarking"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == false),
      expression: "isGroupFilter == false"
    }]
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('Table', {
    attrs: {
      "row-class-name": _vm.rowClassName,
      "border": "",
      "columns": _vm.columnsDataTable,
      "data": _vm.invoiceClaimData,
      "width": 1750
    }
  })], 1)]), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGroupFilter == true),
      expression: "isGroupFilter == true"
    }]
  }, [_c('Table', {
    attrs: {
      "row-class-name": _vm.rowClassName,
      "border": "",
      "columns": _vm.columnsGroupTable,
      "data": _vm.invoiceClaimGroupData
    }
  })], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "50%"
    },
    model: {
      value: (_vm.isModalDetail),
      callback: function($$v) {
        _vm.isModalDetail = $$v
      },
      expression: "isModalDetail"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Detail")])], 1), _vm._v(" "), _c('Form', {
    ref: "formDetail",
    attrs: {
      "model": _vm.formDetail
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Tanggal & No. Partai"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formDetail.invoiceDateContainerCode),
      callback: function($$v) {
        _vm.$set(_vm.formDetail, "invoiceDateContainerCode", $$v)
      },
      expression: "formDetail.invoiceDateContainerCode"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formDetail.description),
      callback: function($$v) {
        _vm.$set(_vm.formDetail, "description", $$v)
      },
      expression: "formDetail.description"
    }
  })], 1), _vm._v(" "), _c('FormItem', [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("\n                    Category Claim\n                    ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("\n                    Nilai Klaim\n                    ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("\n                    Keterangan\n                    ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v("\n                    Load date\n                    ")])], 1)], 1), _vm._v(" "), _vm._l((_vm.formDetail.claimDetail), function(item, index) {
    return [_c('FormItem', [_c('Row', {
      attrs: {
        "type": "flex",
        "justify": "space-between"
      }
    }, [_c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_c('Input', {
      attrs: {
        "value": _vm.formDetail.claimDetail[index].category_claim ?
          _vm.formDetail.claimDetail[index].category_claim.code + '. ' + _vm.formDetail.claimDetail[index].category_claim.name :
          '',
        "readonly": ""
      }
    })], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "6"
      }
    }, [(_vm.formDetail.isSpecialMarking) ? _c('Money', _vm._b({
      staticClass: "ivu-input",
      attrs: {
        "readonly": ""
      },
      model: {
        value: (_vm.formDetail.claimDetail[index].claim_value),
        callback: function($$v) {
          _vm.$set(_vm.formDetail.claimDetail[index], "claim_value", $$v)
        },
        expression: "formDetail.claimDetail[index].claim_value"
      }
    }, 'Money', _vm.moneySg, false)) : _c('Money', _vm._b({
      staticClass: "ivu-input",
      attrs: {
        "readonly": ""
      },
      model: {
        value: (_vm.formDetail.claimDetail[index].claim_value),
        callback: function($$v) {
          _vm.$set(_vm.formDetail.claimDetail[index], "claim_value", $$v)
        },
        expression: "formDetail.claimDetail[index].claim_value"
      }
    }, 'Money', _vm.money, false))], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_c('Input', {
      attrs: {
        "type": "textarea",
        "autosize": {
          minRows: 2,
          maxRows: 5
        },
        "readonly": ""
      },
      model: {
        value: (_vm.formDetail.claimDetail[index].description),
        callback: function($$v) {
          _vm.$set(_vm.formDetail.claimDetail[index], "description", $$v)
        },
        expression: "formDetail.claimDetail[index].description"
      }
    })], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "4"
      }
    }, [_c('Input', {
      attrs: {
        "type": "date",
        "readonly": ""
      },
      model: {
        value: (_vm.formDetail.claimDetail[index].load_date),
        callback: function($$v) {
          _vm.$set(_vm.formDetail.claimDetail[index], "load_date", $$v)
        },
        expression: "formDetail.claimDetail[index].load_date"
      }
    })], 1)], 1)], 1)]
  }), _vm._v(" "), _c('FormItem', [_c('Row', [_c('Col', {
    attrs: {
      "span": "12",
      "offset": "11"
    }
  }, [_c('b', [_vm._v("\n                        Total Nilai Klaim :\n                        "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.formDetail.totalClaim))])])])], 1)], 1)], 2)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "50%"
    },
    model: {
      value: (_vm.isModalGroupDetail),
      callback: function($$v) {
        _vm.isModalGroupDetail = $$v
      },
      expression: "isModalGroupDetail"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Detail Group")])], 1), _vm._v(" "), _vm._l((_vm.formDetailGroup), function(claimGroup, index) {
    return [_c('Form', {
      ref: '-claimGroup-' + index,
      refInFor: true,
      attrs: {
        "model": claimGroup
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "Marking Header Code"
      }
    }, [_c('Input', {
      attrs: {
        "readonly": ""
      },
      model: {
        value: (claimGroup.markingHeaderCode),
        callback: function($$v) {
          _vm.$set(claimGroup, "markingHeaderCode", $$v)
        },
        expression: "claimGroup.markingHeaderCode"
      }
    })], 1), _vm._v(" "), _c('Form-item', {
      attrs: {
        "label": "Tanggal & No. Partai"
      }
    }, [_c('Input', {
      attrs: {
        "readonly": ""
      },
      model: {
        value: (claimGroup.invoiceDateContainerCode),
        callback: function($$v) {
          _vm.$set(claimGroup, "invoiceDateContainerCode", $$v)
        },
        expression: "claimGroup.invoiceDateContainerCode"
      }
    }), _vm._v(" "), _c('Input', {
      staticStyle: {
        "display": "none"
      },
      model: {
        value: (claimGroup.markingHeaderId),
        callback: function($$v) {
          _vm.$set(claimGroup, "markingHeaderId", $$v)
        },
        expression: "claimGroup.markingHeaderId"
      }
    }), _vm._v(" "), _c('Input', {
      staticStyle: {
        "display": "none"
      },
      model: {
        value: (claimGroup.receivableId),
        callback: function($$v) {
          _vm.$set(claimGroup, "receivableId", $$v)
        },
        expression: "claimGroup.receivableId"
      }
    })], 1), _vm._v(" "), _c('Form-item', {
      attrs: {
        "label": "Keterangan"
      }
    }, [_c('Input', {
      attrs: {
        "readonly": ""
      },
      model: {
        value: (claimGroup.description),
        callback: function($$v) {
          _vm.$set(claimGroup, "description", $$v)
        },
        expression: "claimGroup.description"
      }
    })], 1), _vm._v(" "), _c('FormItem', [_c('Row', {
      attrs: {
        "type": "flex",
        "justify": "space-between"
      }
    }, [_c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_vm._v("\n                        Category Claim\n                        ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_vm._v("\n                        Nilai Klaim\n                        ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_vm._v("\n                        Keterangan\n                        ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "4"
      }
    }, [_vm._v("\n                        Load date\n                        ")])], 1)], 1), _vm._v(" "), _vm._l((claimGroup.claimDetail), function(item, index) {
      return [_c('FormItem', [_c('Row', {
        attrs: {
          "type": "flex",
          "justify": "space-between"
        }
      }, [_c('Col', {
        attrs: {
          "span": "6"
        }
      }, [_c('Input', {
        attrs: {
          "value": claimGroup.claimDetail[index].category_claim ?
            claimGroup.claimDetail[index].category_claim.code + '. ' + claimGroup.claimDetail[index].category_claim.name :
            '',
          "readonly": ""
        }
      })], 1), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "6"
        }
      }, [(claimGroup.isSpecialMarking) ? _c('Money', _vm._b({
        staticClass: "ivu-input",
        attrs: {
          "readonly": ""
        },
        model: {
          value: (item.claim_value),
          callback: function($$v) {
            _vm.$set(item, "claim_value", $$v)
          },
          expression: "item.claim_value"
        }
      }, 'Money', _vm.moneySg, false)) : _c('Money', _vm._b({
        staticClass: "ivu-input",
        attrs: {
          "readonly": ""
        },
        model: {
          value: (item.claim_value),
          callback: function($$v) {
            _vm.$set(item, "claim_value", $$v)
          },
          expression: "item.claim_value"
        }
      }, 'Money', _vm.moneySg, false))], 1), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "6"
        }
      }, [_c('Input', {
        attrs: {
          "type": "textarea",
          "autosize": {
            minRows: 2,
            maxRows: 5
          },
          "readonly": ""
        },
        model: {
          value: (item.description),
          callback: function($$v) {
            _vm.$set(item, "description", $$v)
          },
          expression: "item.description"
        }
      })], 1), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "4"
        }
      }, [_c('Input', {
        attrs: {
          "type": "date",
          "readonly": ""
        },
        model: {
          value: (item.load_date),
          callback: function($$v) {
            _vm.$set(item, "load_date", $$v)
          },
          expression: "item.load_date"
        }
      })], 1)], 1)], 1)]
    }), _vm._v(" "), _c('FormItem', [_c('Row', [_c('Col', {
      attrs: {
        "span": "12",
        "offset": "11"
      }
    }, [_c('b', [_vm._v("\n                            Total Nilai Klaim :\n                            "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(claimGroup.totalClaim))])])])], 1)], 1)], 2), _vm._v(" "), _c('hr')]
  }), _vm._v(" "), _c('b', [_vm._v("\n            Total Nilai Klaim :\n            "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.claimTotalGroup))])])], 2), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Konfirmasi",
      "ok-text": "Ya",
      "cancel-text": "Tidak"
    },
    on: {
      "on-ok": _vm.updateClaimList,
      "on-cancel": _vm.cancelUpdateClaimList
    },
    model: {
      value: (_vm.isModalConfirm),
      callback: function($$v) {
        _vm.isModalConfirm = $$v
      },
      expression: "isModalConfirm"
    }
  }, [_vm._v("\n        Silahkan pilih kategori NT yang sesuai:\n        "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('Select', {
    staticStyle: {
      "display": "revert"
    },
    attrs: {
      "placeholder": "Pilih Kategori NT"
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('Option', {
      key: category.id,
      attrs: {
        "value": category.id
      }
    }, [_vm._v(_vm._s(category.value) + "\n              ")])
  }), 1), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmationMessage)
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Konfirmasi Claim Group",
      "ok-text": "Ya",
      "cancel-text": "Tidak"
    },
    on: {
      "on-ok": _vm.updateClaimListGroup,
      "on-cancel": _vm.cancelUpdateClaimListGroup
    },
    model: {
      value: (_vm.isModalConfirmGroup),
      callback: function($$v) {
        _vm.isModalConfirmGroup = $$v
      },
      expression: "isModalConfirmGroup"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.confirmationMessage))])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "60%"
    },
    on: {
      "on-cancel": _vm.afterUploadFile
    },
    model: {
      value: (_vm.isModalUploadFile),
      callback: function($$v) {
        _vm.isModalUploadFile = $$v
      },
      expression: "isModalUploadFile"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Upload File")])], 1), _vm._v(" "), _c('Form', {
    ref: "uploadFileForm",
    attrs: {
      "model": _vm.formUploadFile
    }
  }, [_c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formUploadFile.claimId),
      callback: function($$v) {
        _vm.$set(_vm.formUploadFile, "claimId", $$v)
      },
      expression: "formUploadFile.claimId"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formUploadFile.markingHeaderCode),
      callback: function($$v) {
        _vm.$set(_vm.formUploadFile, "markingHeaderCode", $$v)
      },
      expression: "formUploadFile.markingHeaderCode"
    }
  }), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "file"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formUploadFile.imageUploaded.length > 0),
      expression: "formUploadFile.imageUploaded.length > 0"
    }],
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, _vm._l((_vm.formUploadFile.imageUploaded), function(imgUpl) {
    return _c('div', [_c('img', {
      staticStyle: {
        "max-width": "100%",
        "max-height": "500px",
        "width": "auto",
        "padding": "10px"
      },
      attrs: {
        "src": imgUpl,
        "alt": "Uploaded Image"
      }
    })])
  }), 0), _vm._v(" "), (_vm.isGroupFilter) ? _c('Upload', {
    ref: "upload",
    attrs: {
      "multiple": "",
      "type": "drag",
      "name": "fileUploaded",
      "action": this.serverUrlUploadFile,
      "before-upload": _vm.handleBeforeUpload,
      "accept": "image/*"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag files here to upload")])], 1)]) : _c('Upload', {
    ref: "upload",
    attrs: {
      "type": "drag",
      "multiple": "",
      "name": "fileUploaded",
      "action": this.serverUrlUploadFile,
      "before-upload": _vm.handleBeforeUpload,
      "accept": "image/*"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag files here to upload")])], 1)]), _vm._v(" "), _c('Progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProgress),
      expression: "isProgress"
    }],
    attrs: {
      "percent": _vm.pValue,
      "stroke-width": 20
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.afterUploadFile
    }
  }, [_c('span', [_vm._v("OK")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "60%"
    },
    model: {
      value: (_vm.isModalEdit),
      callback: function($$v) {
        _vm.isModalEdit = $$v
      },
      expression: "isModalEdit"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Edit")])], 1), _vm._v(" "), _c('Form', {
    ref: "formEdit",
    attrs: {
      "model": _vm.formEdit
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Tanggal - No. Partai & Keterangan"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "disabled": ""
    },
    model: {
      value: (_vm.formEdit.invoiceDateContainerCodeDescription),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "invoiceDateContainerCodeDescription", $$v)
      },
      expression: "formEdit.invoiceDateContainerCodeDescription"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formEdit.claimId),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "claimId", $$v)
      },
      expression: "formEdit.claimId"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formEdit.markingHeaderId),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "markingHeaderId", $$v)
      },
      expression: "formEdit.markingHeaderId"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formEdit.receivableId),
      callback: function($$v) {
        _vm.$set(_vm.formEdit, "receivableId", $$v)
      },
      expression: "formEdit.receivableId"
    }
  })], 1), _vm._v(" "), _c('FormItem', [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("\n                    Category Klaim\n                    ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_vm._v("\n                    Nilai Klaim\n                    ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("\n                    Keterangan\n                    ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.formEdit.claimDetail), function(item, index) {
    return [(item.formDynamic.items[0].status) ? _c('FormItem', {
      key: index
    }, [_c('Row', {
      attrs: {
        "type": "flex",
        "justify": "space-between"
      }
    }, [_c('Col', {
      attrs: {
        "span": "8"
      }
    }, [_c('Select', {
      attrs: {
        "placeholder": "Select",
        "clearable": "",
        "filterable": ""
      },
      model: {
        value: (item.formDynamic.items[0].categoryClaimId),
        callback: function($$v) {
          _vm.$set(item.formDynamic.items[0], "categoryClaimId", $$v)
        },
        expression: "item.formDynamic.items[0].categoryClaimId"
      }
    }, _vm._l((_vm.categoryClaims), function(categoryClaim) {
      return _c('Option', {
        key: categoryClaim.id,
        attrs: {
          "value": categoryClaim.id
        }
      }, [_vm._v("  " + _vm._s(((categoryClaim.code) + ". " + (categoryClaim.name) + " ")))])
    }), 1)], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "5"
      }
    }, [(_vm.formEdit.isSpecialMarking) ? _c('Money', _vm._b({
      staticClass: "ivu-input",
      attrs: {
        "disabled": _vm.formEdit.isApprove
      },
      model: {
        value: (item.formDynamic.items[0].claimValue),
        callback: function($$v) {
          _vm.$set(item.formDynamic.items[0], "claimValue", $$v)
        },
        expression: "item.formDynamic.items[0].claimValue"
      }
    }, 'Money', _vm.moneySg, false)) : _c('Money', _vm._b({
      staticClass: "ivu-input",
      attrs: {
        "disabled": _vm.formEdit.isApprove
      },
      model: {
        value: (item.formDynamic.items[0].claimValue),
        callback: function($$v) {
          _vm.$set(item.formDynamic.items[0], "claimValue", $$v)
        },
        expression: "item.formDynamic.items[0].claimValue"
      }
    }, 'Money', _vm.money, false))], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "8"
      }
    }, [_c('Input', {
      model: {
        value: (item.formDynamic.items[0].description),
        callback: function($$v) {
          _vm.$set(item.formDynamic.items[0], "description", $$v)
        },
        expression: "item.formDynamic.items[0].description"
      }
    })], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "2"
      }
    }, [_c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.handleEditRemove(index)
        }
      }
    }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e()]
  }), _vm._v(" "), _c('FormItem', [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleEditAdd
    }
  }, [_vm._v(" + Tambah Nilai Klaim")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "14"
    }
  }, [_c('b', [_vm._v("\n                        Total Nilai Klaim :\n                        "), (_vm.formEdit.isSpecialMarking) ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.formEdit.currency) + ". " + _vm._s(_vm._f("currencyInter")(_vm.claimValueTotal)))]) : _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.formEdit.currency) + ". " + _vm._s(_vm._f("currency")(_vm.claimValueTotal)))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2"
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingEdit
    },
    on: {
      "click": _vm.postEdit
    }
  }, [(!_vm.isLoadingEdit) ? _c('span', [_vm._v("Simpan")]) : _c('span', [_vm._v("Uploading.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "50%"
    },
    model: {
      value: (_vm.isModalGroupEdit),
      callback: function($$v) {
        _vm.isModalGroupEdit = $$v
      },
      expression: "isModalGroupEdit"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Edit Group")])], 1), _vm._v(" "), _c('Form', {
    ref: _vm.formEditGroup,
    attrs: {
      "model": _vm.formEditGroup
    }
  }, [_vm._l((_vm.formEditGroup.claimLists), function(claimGroupEdit, i) {
    return [_c('Form-item', {
      attrs: {
        "label": "Tanggal - No. Partai & Keterangan"
      }
    }, [_c('Input', {
      attrs: {
        "type": "textarea",
        "autosize": {
          minRows: 2,
          maxRows: 5
        },
        "disabled": ""
      },
      model: {
        value: (claimGroupEdit.invoiceDateContainerCodeDescription),
        callback: function($$v) {
          _vm.$set(claimGroupEdit, "invoiceDateContainerCodeDescription", $$v)
        },
        expression: "claimGroupEdit.invoiceDateContainerCodeDescription"
      }
    }), _vm._v(" "), _c('Input', {
      staticStyle: {
        "display": "none"
      },
      model: {
        value: (claimGroupEdit.claimId),
        callback: function($$v) {
          _vm.$set(claimGroupEdit, "claimId", $$v)
        },
        expression: "claimGroupEdit.claimId"
      }
    }), _vm._v(" "), _c('Input', {
      staticStyle: {
        "display": "none"
      },
      model: {
        value: (claimGroupEdit.markingHeaderId),
        callback: function($$v) {
          _vm.$set(claimGroupEdit, "markingHeaderId", $$v)
        },
        expression: "claimGroupEdit.markingHeaderId"
      }
    }), _vm._v(" "), _c('Input', {
      staticStyle: {
        "display": "none"
      },
      model: {
        value: (claimGroupEdit.receivableId),
        callback: function($$v) {
          _vm.$set(claimGroupEdit, "receivableId", $$v)
        },
        expression: "claimGroupEdit.receivableId"
      }
    })], 1), _vm._v(" "), _c('Form-item', {
      attrs: {
        "label": "Marking Header Code"
      }
    }, [_c('Input', {
      attrs: {
        "disabled": ""
      },
      model: {
        value: (claimGroupEdit.markingHeaderCode),
        callback: function($$v) {
          _vm.$set(claimGroupEdit, "markingHeaderCode", $$v)
        },
        expression: "claimGroupEdit.markingHeaderCode"
      }
    })], 1), _vm._v(" "), _c('FormItem', [_c('Row', [_c('Col', {
      attrs: {
        "span": "10"
      }
    }, [_vm._v("\n                        Nilai Klaim\n                        ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "12",
        "offset": "1"
      }
    }, [_vm._v("\n                        Keterangan Klaim\n                        ")])], 1)], 1), _vm._v(" "), _vm._l((claimGroupEdit.claimDetail), function(item, index) {
      return [(item.status) ? _c('FormItem', {
        key: i + '-' + index
      }, [_c('Row', [_c('Col', {
        attrs: {
          "span": "8"
        }
      }, [(claimGroupEdit.isSpecialMarking) ? _c('Money', _vm._b({
        staticClass: "ivu-input",
        nativeOn: {
          "focusout": function($event) {
            return _vm.changeClaimValue()
          }
        },
        model: {
          value: (item.claimValue),
          callback: function($$v) {
            _vm.$set(item, "claimValue", $$v)
          },
          expression: "item.claimValue"
        }
      }, 'Money', _vm.moneySg, false)) : _c('Money', _vm._b({
        staticClass: "ivu-input",
        nativeOn: {
          "focusout": function($event) {
            return _vm.changeClaimValue()
          }
        },
        model: {
          value: (item.claimValue),
          callback: function($$v) {
            _vm.$set(item, "claimValue", $$v)
          },
          expression: "item.claimValue"
        }
      }, 'Money', _vm.money, false))], 1), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "10",
          "offset": "1"
        }
      }, [_c('Input', {
        model: {
          value: (item.description),
          callback: function($$v) {
            _vm.$set(item, "description", $$v)
          },
          expression: "item.description"
        }
      })], 1), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "4",
          "offset": "1"
        }
      }, [_c('Button', {
        attrs: {
          "type": "error"
        },
        on: {
          "click": function($event) {
            return _vm.handleEditRemoveGroup(index, claimGroupEdit.claimGroupId)
          }
        }
      }, [_vm._v("Delete")])], 1)], 1)], 1) : _vm._e()]
    }), _vm._v(" "), _c('FormItem', [_c('Row', [_c('Col', {
      attrs: {
        "span": "8"
      }
    }, [_c('Button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          return _vm.handleEditAddGroup(claimGroupEdit.claimGroupId)
        }
      }
    }, [_vm._v(" + Tambah Nilai\n                            Klaim")])], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "10",
        "offset": "1"
      }
    }, [_c('b', [_vm._v("\n                            Total Nilai Klaim :\n                            "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(claimGroupEdit.claimValueTotal))])])])], 1)], 1)]
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingEdit
    },
    on: {
      "click": _vm.postEditGroup
    }
  }, [(!_vm.isLoadingEdit) ? _c('span', [_vm._v("Simpan")]) : _c('span', [_vm._v("Uploading.....")])])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "Konfirmasi",
      "ok-text": "Ya",
      "cancel-text": "Tidak"
    },
    on: {
      "on-cancel": function($event) {
        _vm.confirmDescription = ''
      }
    },
    model: {
      value: (_vm.isModalDelete),
      callback: function($$v) {
        _vm.isModalDelete = $$v
      },
      expression: "isModalDelete"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Hapus Klaim")])], 1), _vm._v(" "), [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(" Marking ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" : ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "19"
    }
  }, [_vm._v(" " + _vm._s(this.formDeleteClaim.marking) + " ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(" Nominal ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" : ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "19"
    }
  }, [_vm._v(" " + _vm._s(this.formDeleteClaim.totalClaim) + " ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(" Keterangan ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v(" : ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "19"
    }
  }, [_vm._v(" " + _vm._s(this.formDeleteClaim.marking) + " ")])], 1)], 1), _vm._v(" "), _c('hr'), _c('br'), _vm._v(" "), _c('i', [_vm._v(" Ketik "), _c('b', [_vm._v(_vm._s(_vm.formDeleteClaim.marking))]), _vm._v(" untuk melanjutkan !")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (this.formDeleteClaim.claimId),
      callback: function($$v) {
        _vm.$set(this.formDeleteClaim, "claimId", $$v)
      },
      expression: "this.formDeleteClaim.claimId"
    }
  }), _vm._v(" "), _c('Input', {
    model: {
      value: (_vm.confirmDescription),
      callback: function($$v) {
        _vm.confirmDescription = $$v
      },
      expression: "confirmDescription"
    }
  })], _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.formDeleteClaim.marking).toUpperCase() == _vm.confirmDescription.toUpperCase()),
      expression: "(formDeleteClaim.marking).toUpperCase() == confirmDescription.toUpperCase()"
    }],
    attrs: {
      "type": "error",
      "long": ""
    },
    on: {
      "click": _vm.deleteClaim
    }
  }, [_vm._v("Hapus")])], 1)], 2), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "50%"
    },
    on: {
      "on-ok": function($event) {
        _vm.imageUrlFiles = []
      },
      "on-cancel": function($event) {
        _vm.imageUrlFiles = []
      }
    },
    model: {
      value: (_vm.isModalImageOss),
      callback: function($$v) {
        _vm.isModalImageOss = $$v
      },
      expression: "isModalImageOss"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Images")])], 1), _vm._v(" "), (_vm.imageUrlFiles.length) ? _c('SliderClaimImages', {
    key: _vm.imageUrlFiles.join(),
    attrs: {
      "slides": _vm.imageUrlFiles
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "10px"
    }
  }, [_c('ButtonGroup', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.zoomImage('in')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-add"
    }
  }), _vm._v(" Zoom In\n                ")], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.zoomImage('out')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-remove"
    }
  }), _vm._v(" Zoom Out\n                ")], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        return _vm.zoomImage('reset')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-refresh"
    }
  }), _vm._v(" Reset Zoom\n                ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "50%"
    },
    model: {
      value: (_vm.isModalImage),
      callback: function($$v) {
        _vm.isModalImage = $$v
      },
      expression: "isModalImage"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Image")])], 1), _vm._v(" "), _c('img', {
    style: ({
      transform: ("scale(" + _vm.imageZoomLevel + ")"),
      transformOrigin: 'center center',
      transition: 'transform 0.2s ease',
      maxWidth: '100%',
      width: 'auto',
      padding: '10px'
    }),
    attrs: {
      "src": _vm.imageUrl,
      "alt": "Uploaded Image"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "10px"
    }
  }, [_c('ButtonGroup', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.zoomImage('in')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-add"
    }
  }), _vm._v(" Zoom In\n                ")], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.zoomImage('out')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-remove"
    }
  }), _vm._v(" Zoom Out\n                ")], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        return _vm.zoomImage('reset')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-refresh"
    }
  }), _vm._v(" Reset Zoom\n                ")], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6840a05c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/claim/ClaimList.vue
// module id = 1822
// module chunks = 1